import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function CheckoutCancel() {
  return (
    <div className="max-w-2xl mx-auto px-6 py-32 text-center" data-testid="checkout-cancel-page">
      <XCircle size={48} className="mx-auto mb-6 text-zinc-400" strokeWidth={1.5} />
      <h1 className="text-4xl font-black tracking-tighter mb-4" style={{ fontFamily: "Outfit" }}>
        Checkout cancelled.
      </h1>
      <p className="text-zinc-600 mb-8">
        No charge was made. Your bag is still here — continue when you&apos;re ready.
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 bg-zinc-900 text-white px-8 py-3 text-xs uppercase tracking-[0.25em] font-bold hover:bg-black transition"
      >
        Back to Shop
      </Link>
    </div>
  );
}
